import { useQuery } from "@tanstack/react-query";
import { useGeotabClient } from "@/components/GeotabClientContext";

export function useAddInApplications() {
  const { geotabClient, activeSessionId } = useGeotabClient();
  return useQuery({
    queryKey: ["addInApplications", activeSessionId],

    queryFn: ({ signal }) => {
      return geotabClient.get("AddIn", {}, 1000, signal);
    }
  });
}
